import React from 'react'

import {
  StyledHistoryIndex,
  StyledHistoryIndexList,
  StyledHistoryIndexListItem,
  StyledHistoryIndexLabel,
  StyledIndexButton
} from './styles'


const HistoryIndex = ({
  items,
  preIndexLabel,
  postIndexLabel,
  currentIndex,
  onIndexButtonClick,
  theme
}) => (
  <StyledHistoryIndex>
    {
      !!preIndexLabel && (
        <StyledHistoryIndexLabel>
          {preIndexLabel}
        </StyledHistoryIndexLabel>
      )
    }

    <StyledHistoryIndexList className='IndexList'>
      {
        items.map(({
          label,
          target: sectionTarget
        }, idx) => (
          <StyledHistoryIndexListItem
            key={sectionTarget}
          >
            <StyledIndexButton
              variant={theme}
              middle={currentIndex - 1 === idx}
              current={currentIndex === idx}
              theme="reset"
              onClick={() => onIndexButtonClick(sectionTarget, idx)}>
              <span>{label}</span>
            </StyledIndexButton>
          </StyledHistoryIndexListItem>
        ))
      }

    </StyledHistoryIndexList>

    {
      !!postIndexLabel &&
      <StyledHistoryIndexLabel>
        {postIndexLabel}
      </StyledHistoryIndexLabel>
    }

  </StyledHistoryIndex>
)

export default HistoryIndex
